$(document).ready(
    function () {

        if ($("#event_ticket_category_id").val() !== undefined && $("#event_ticket_category_id").val() != null && $("#event_ticket_category_id").val() !== "") {

            let event_ticket_category_update_ajax_lock = false;

            $(document).on("submit", "#event_ticket_category_form", function () {
                if($('#event-ticket-category-price-wrapper #event-ticket-category-price-intervals-wrapper').find('input').length > 0 && !$('#event-ticket-category-price-wrapper .event-ticket-category-price-weekdays-wrapper[pos="0"]').hasClass('d-none')){
                    popupAlert(3000, "danger", 'Du kan ikke ha både intervall og ukedagpriser samtidig');
                    return false;
                }
                if($('#event-ticket-category-price-pos-wrapper #event-ticket-category-price-intervals-pos-wrapper').find('input').length > 0 && !$('#event-ticket-category-price-pos-wrapper .event-ticket-category-price-weekdays-wrapper[pos="1"]').hasClass('d-none')){
                    popupAlert(3000, "danger", 'Du kan ikke ha både intervall og ukedagpriser samtidig');
                    return false;
                }

                if (!event_ticket_category_update_ajax_lock) {

                    if ($("#event-ticket-category-price-intervals-wrapper").length > 0 && !validateTicketIntervals()) {
                        return false;
                    }

                    let event_id = $("#event_id").val();

                    event_ticket_category_update_ajax_lock = true;

                    $(':disabled').each(function () {
                        $(this).attr('data-was-disabled', '1');
                        $(this).removeAttr('disabled');
                    });

                    let formData = new FormData(document.getElementById('event_ticket_category_form'));

                    $.ajax({
                        type: 'POST',
                        url: "/ajax/organizer_event_ticket_category/update",
                        data: formData,
                        async: true,
                        cache: false,
                        processData: false,
                        contentType: false
                    })
                        .done(function (data) {

                            if (data.message !== undefined && data.message !== null) {

                                prependAlert('#div_event_ticket_category_button', data.message, 'success', null, '#event_ticket_category_form');
                                $('.card-box-to-hide').hide();
                                $('#event_ticket_category_button').hide();

                                setTimeout(function () {
                                    document.location.href = "/organizer/event/" + event_id + "/ticket_category/";
                                }, 2000);

                            }

                        })
                        .fail(function (data) {

                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }

                            if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                                prependAlert('#div_event_ticket_category_button', data.responseJSON.error_message, 'danger', null, '#event_ticket_category_form')
                            }

                            event_ticket_category_update_ajax_lock = false;

                        })
                        .always(function () {
                            event_ticket_category_update_ajax_lock = false;

                            $('[data-was-disabled="1"]').each(function () {
                                $(this).prop('disabled', true);
                            });
                        });

                }

                return false;

            });

            function validateTicketIntervals() {
                const intervals = [];

                $('[name^="event_ticket_category_price_intervals["]').each(function() {
                    const match = this.name.match(/\[(\d+)\]\[(start|end)\]$/);
                    if (match) {
                        const index = match[1];
                        const type = match[2];
                        const value = this.value;

                        if (!intervals[index]) {
                            intervals[index] = { start: null, end: null };
                        }
                        intervals[index][type] = value;
                    }
                });

                const validIntervals = Object.values(intervals)
                    .filter(int => int.start && int.end)
                    .sort((a, b) => a.start.localeCompare(b.start));

                for (const interval of validIntervals) {
                    if (interval.start > interval.end) {
                        let invalidMessage = $("#event-ticket-category-price-intervals-wrapper").data('invalid-interval-message')
                        prependAlert('#div_event_ticket_category_button', invalidMessage, 'danger', null, '#event_ticket_category_form')
                        return false;
                    }
                }

                for (let i = 1; i < validIntervals.length; i++) {
                    const prev = validIntervals[i - 1];
                    const current = validIntervals[i];

                    if (current.start < prev.end) {
                        let intervalOverlapMessage = $("#event-ticket-category-price-intervals-wrapper").data('interval-overlap-error-message')
                        prependAlert('#div_event_ticket_category_button', intervalOverlapMessage, 'danger', null, '#event_ticket_category_form')
                        return false;
                    }
                }

                return true;
            }

        }

    }
);